import { find } from 'lodash';

export const getPageElements = ({ acf: { htmls, strings, images }}) =>
  Object.assign({},
    ...(htmls || []).map(({ label, body }) => ({ [label]: body })),
    ...(strings || []).map(({ label, text }) => ({ [label]: text })),
    ...(images || []).map(({ label, imange }) => ({ [label]: imange }))
  );